import script from "./AccountSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./AccountSkeleton.vue?vue&type=style&index=0&id=27b4af4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b4af4a"]])

export default __exports__